// @flow

export const WIDGET_GET_LAST_REG_INITIATING = 'WIDGET_GET_LAST_REG_INITIATING'
export const WIDGET_GET_LAST_REG_INITIATED = 'WIDGET_GET_LAST_REG_INITIATED'
